/**
 * @generated SignedSource<<a5af9c350864e29639a05115c2ed6fec>>
 * @relayHash 5974416206b0e08d13092122cdcdd8d9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5974416206b0e08d13092122cdcdd8d9

import { ConcreteRequest } from 'relay-runtime';
export type DoctorNetworkRole = "FAMILY_DOCTOR" | "GATEKEEPER" | "SPECIALIST";
export type Ch_deleteDoctorNetworkInput = {
  id: string;
};
export type chDeleteDoctorNetworkMutation$variables = {
  input: Ch_deleteDoctorNetworkInput;
};
export type chDeleteDoctorNetworkMutation$data = {
  readonly deleteDoctorNetwork: {
    readonly doctorNetwork: {
      readonly createdAt: string;
      readonly patientId: string;
      readonly role: DoctorNetworkRole;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly doctorNetworkId?: number;
      readonly message?: string;
    }> | null;
  };
};
export type chDeleteDoctorNetworkMutation = {
  response: chDeleteDoctorNetworkMutation$data;
  variables: chDeleteDoctorNetworkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/)
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doctorNetworkId",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "DoctorNetworkNotFound",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chDeleteDoctorNetworkMutation",
    "selections": [
      {
        "alias": "deleteDoctorNetwork",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteDoctorNetworkPayload",
        "kind": "LinkedField",
        "name": "ch_deleteDoctorNetwork",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DoctorNetwork",
            "kind": "LinkedField",
            "name": "doctorNetwork",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chDeleteDoctorNetworkMutation",
    "selections": [
      {
        "alias": "deleteDoctorNetwork",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteDoctorNetworkPayload",
        "kind": "LinkedField",
        "name": "ch_deleteDoctorNetwork",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DoctorNetwork",
            "kind": "LinkedField",
            "name": "doctorNetwork",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5974416206b0e08d13092122cdcdd8d9",
    "metadata": {},
    "name": "chDeleteDoctorNetworkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f5ba1a0bb71f72f4ccece5276b1b1a28";

export default node;
